module.exports = __webpack_public_path__ + "img/check_mark_button.e1c8e011.gif";